import React from 'react';
import classNames from 'classnames';
export default function Switch(props) {
    var classes = classNames({ 'custom-control custom-switch': true });
    return (React.createElement("div", { className: classes + (props.className ? ' ' + props.className : '') },
        React.createElement("input", { disabled: props.disabled, type: "checkbox", className: "custom-control-input", name: props.id, id: props.id, checked: props.checked, onChange: props.onChange ? props.onChange : null }),
        React.createElement("label", { className: "custom-control-label", htmlFor: props.id }, props.children)));
}
